import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const StudyMaterialOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M21.82 17.35 17.6 5.01c-.14-.42-.54-.68-.96-.68-.11 0-.22.02-.33.05l-3.63 1.24V4.58c0-.75-.61-1.36-1.36-1.36H7.87c-.75 0-1.36.61-1.36 1.36v1.34H3.47c-.74 0-1.34.6-1.34 1.34v11.22c0 .74.6 1.34 1.34 1.34h3.18c.22 0 .43-.06.61-.15.19.09.39.15.62.15h3.45c.75 0 1.36-.61 1.36-1.36V9.72l3.3 9.63c.14.42.54.68.96.68.11 0 .22-.02.33-.05l3.93-1.34c.53-.18.81-.76.63-1.28l-.02-.01Zm-15.39.92H3.69V7.49h2.74v10.78Zm4.69 0H8.07V4.78h3.05v13.49Zm2.29-11.25 2.88-.99 2.97 8.68-2.9.94-2.96-8.64.01.01Zm3.87 11.3-.41-1.18 2.9-.94.39 1.14-2.88.99v-.01Z"
      fill={color}
    />
  </Svg>
)

export default StudyMaterialOutlined
